module.exports = __webpack_public_path__ + "img/live_weixin2.5b15117f.png";